import * as api from "services/api";

import { EMPTY_FILTERS } from "./constants";

export const parseResponse = async response => {
	let result;

	try {
		result = await response.json();
	} catch (error) {
		throw new Error("Não foi possível interpretar a resposta do servidor.");
	}

	if (!response.ok || !result?.isValid) {
		throw new Error(
			result?.errors?.default || "Não foi possível concluir a operação."
		);
	}

	return result.model;
};

const authorization = token => ({
	Authorization: `Bearer ${token}`
});

export const buildBenefitsQuery = ({
	filters = {},
	skip = 0,
	take = 10,
	sort = "name",
	desc = false
} = {}) => {
	const params = new URLSearchParams({
		skip: String(skip),
		take: String(take),
		sort,
		desc: String(desc)
	});

	Object.keys(filters).forEach(key => {
		if (filters[key] !== "" && filters[key] !== null && filters[key] !== undefined) {
			params.set(key, filters[key]);
		}
	});

	return params.toString();
};

export const readBenefitsFilters = search => {
	const params = new URLSearchParams(search || "");

	return Object.keys(EMPTY_FILTERS).reduce(
		(filters, key) => ({
			...filters,
			[key]: params.get(key) || ""
		}),
		{ ...EMPTY_FILTERS }
	);
};

export const buildBenefitsFilterSearch = (filters, currentSearch = "") => {
	const params = new URLSearchParams(currentSearch);

	Object.keys(EMPTY_FILTERS).forEach(key => {
		const value = filters[key];

		if (value !== "" && value !== null && value !== undefined) {
			params.set(key, value);
		} else {
			params.delete(key);
		}
	});

	return params.toString();
};

export const getBenefits = async (options, token) => {
	const response = await api.sendGet(
		`/user-benefits?${buildBenefitsQuery(options)}`,
		authorization(token)
	);
	return parseResponse(response);
};

export const getBenefitDetails = async (userId, token) => {
	const response = await api.sendGet(
		`/user-benefits/${userId}`,
		authorization(token)
	);
	return parseResponse(response);
};

export const updateLifeInsurance = async (userId, model, token) => {
	const response = await api.sendPut(
		`/user-benefits/${userId}/life-insurance`,
		model,
		authorization(token)
	);
	return parseResponse(response);
};

export const updateDit = async (userId, model, token) => {
	const response = await api.sendPut(
		`/user-benefits/${userId}/dit`,
		model,
		authorization(token)
	);
	return parseResponse(response);
};

export const createObservation = async (userId, note, token) => {
	const response = await api.sendPost(
		`/user-benefits/${userId}/observations`,
		{ note },
		authorization(token)
	);
	return parseResponse(response);
};
